import { action, computed, observable } from 'mobx';
import { paymentApi } from '@/services';
import { PaymentType, GetPaymentReq } from '@/services/types';
export class Order {
  @observable accessor order: PaymentType = {};

  @action
  getOrder({ paymentId, secret, accessToken }: GetPaymentReq) {
    return paymentApi
      .getPayment({
        body: {
          paymentId,
          secret,
          accessToken
        }
      })
      .then(order => {
        if (order) {
          this.setOrder(order);
        }
      });
  }

  @action
  setOrder(order: PaymentType) {
    this.order = order;
  }

  @computed
  get id() {
    return this.order.id || '';
  }
  @computed
  get loaded() {
    return !!this.order.id;
  }
  @computed
  get status() {
    return this.order.status;
  }
  @computed
  get productInfos() {
    return this.order.productInfos || [];
  }
  @computed
  get productName() {
    return this.order.productInfos
      ?.map(product => {
        return product.productTitle;
      })
      .join(' ');
  }
  @computed
  get availableCards() {
    return this.order.availableCards || [];
  }
  @computed
  get deadline() {
    return this.order.deadline;
  }
  @computed
  get gmoShopId() {
    return this.order.gmoShopId;
  }
  @computed
  get total() {
    return this.order.total;
  }
  @computed
  get email() {
    return this.order.email;
  }
  @computed
  get merchantInfo() {
    return this.order.merchantInfo;
  }
  @computed
  get note() {
    return this.order.note;
  }

  @computed
  get returnUrl() {
    return this.order.returnUrl;
  }
  @computed
  get errorMsg() {
    return this.order.errorMsg;
  }
  @computed
  get cardNetworks() {
    return this.order.cardNetworks;
  }
  @computed
  get payMethods() {
    return this.order.payMethods;
  }
  @computed
  get selectedMethod() {
    return this.order.selectedMethod;
  }
}

export default new Order();
